// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__1agYA","vertical":"styles_vertical__36o9G"};